module.exports = __webpack_public_path__ + "static/1-72ca389189c139f3c634b2db1acf1c69.png";